let language = {
    DASHBOARD_GUIDE_TITLE:"Welcome to {{appName}}, lets get started:",
    DASHBOARD_GUIDE_STEP_1:"Step 1",
    DASHBOARD_GUIDE_STEP_2:"Step 2",
    DASHBOARD_GUIDE_STEP_3:"Step 3",
    DASHBOARD_GUIDE_STEP_4:"Step 4",
    DASHBOARD_GUIDE_STEP_5:"Step 5",
    DASHBOARD_GUIDE_STORE:"Connect Your Store with {{appName}}",
    DASHBOARD_GUIDE_STORE_DES:"Integrate your Woo commerce or Shopify store with {{appName}} easily. Sync products and start selling without hassle.",
    DASHBOARD_GUIDE_STORE_PRODUCT:"Add Products to Your Store",
    DASHBOARD_GUIDE_STORE_PRODUCT_DES:"Add custom products using our design tools. Set prices and write compelling descriptions.",
    DASHBOARD_GUIDE_SAMPLE_ORDER:"Order a Sample",
    DASHBOARD_GUIDE_SAMPLE_ORDER_DES:"Order a sample to check the quality, colors, and materials of your custom product before selling.",

    DASHBOARD_GUIDE_CUSTOMER_ORDER:"Check Customer Orders",
    DASHBOARD_GUIDE_CUSTOMER_ORDER_DES:"Monitor incoming orders, review details, and ensure order accuracy.",

    DASHBOARD_GUIDE_COMBINE_ORDER:"Combine Orders",
    DASHBOARD_GUIDE_COMBINE_ORDER_DES:"Combine orders efficiently to save on product costs and streamline logistics.",

    DASHBOARD_GUIDE_START_BTN:"Start",
    DASHBOARD_GUIDE_PAGE_LOADING_TITLE: "Page Loading Issue",
    DASHBOARD_GUIDE_PAGE_LOADING_CONTENT: "An issue occurred while loading this page. Please refresh the page and try again. If the problem persists, feel free to contact our support team at {{supportmail}}.",

};

export { language }